import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

import Auth from "./modules/Auth.store"
import Order from "./modules/Order.store"
import Util from "./modules/Util.store"
import LiveCommerce from "./modules/LiveCommerce.store"
import Basket from "./modules/Basket.store"

Vue.use(Vuex)

const modules = {
    Auth: Auth,
    Order: Order,
    Util: Util,
    LiveCommerce: LiveCommerce,
    Basket: Basket
}

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState({
        key: 'pro-halalize'
    })]
})